/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { real, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const patientPackageRedemptions = sqliteTable('patient_package_redemptions', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  patient_id: text('patient_id'),
  clinic_id: text('clinic_id'),
  patient_package_id: text('patient_package_id'),
  patient_package_item_id: text('patient_package_item_id'),
  child_type: text('child_type'),
  child_inventory_item_id: text('child_inventory_item_id'),
  child_appointment_service_id: text('child_appointment_service_id'),
  source_invoice_id: text('source_invoice_id'),
  source_invoice_item_id: text('source_invoice_item_id'),
  visit_id: text('visit_id'),
  redeemed_quantity: real('redeemed_quantity'),
  item_name_snapshot: text('item_name_snapshot'),
  item_code_snapshot: text('item_code_snapshot'),
  item_type_snapshot: text('item_type_snapshot'),
  unit_price_snapshot: real('unit_price_snapshot'),
  covered_amount: real('covered_amount'),
  redeemed_at: text('redeemed_at'),
  redeemed_by: text('redeemed_by'),
  notes: text('notes'),
  status: text('status'),
  reversed_at: text('reversed_at'),
  reversed_by: text('reversed_by'),
  reverse_reason: text('reverse_reason'),
  reversal_of_redemption_id: text('reversal_of_redemption_id'),
  client_reference: text('client_reference'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  deleted_at: text('deleted_at'),
});
